module.exports = __webpack_public_path__ + "img/hollow-candles_normal@2x.82044ede.svg";